export default {
  GET_LOGS (state, data) {
    state.logs = data.data
  },
  GET_ALL_LOGS (state, data) {
    state.all_logs = data.data
  },

  GET_LOG (state, data) {
    state.log = data.data
  },
  GET_DELETED_LOGS (state, data) {
    state.deleted_logs = data.data
  },
  GET_AUTH_LOGS (state, data) {
    state.auth_logs = data.data
  },
  GET_MORE_AUTH_LOGS(state, data) {
		var logs = data.data
		for (var i = 0; i < logs.length; i++) {
			state.auth_logs.push(logs[i])
		}
	},
  GET_FEATURE_LOGS (state, data) {
    state.feature_logs = data.data
  },
  GET_MORE_FEATURE_LOGS (state, data) {
    var feature_logs = data.data
		for (var i = 0; i < feature_logs.length; i++) {
			state.feature_logs.push(feature_logs[i])
		}
  },
  GET_PASSWORD_RESETS (state, data) {
    state.password_resets_logs = data.data
  }, 
  GET_MORE_PASSWORD_RESETS (state, data) {
    var password_reset__logs = data.data
		for (var i = 0; i < password_reset__logs.length; i++) {
			state.password_resets_logs.push(password_reset__logs[i])
		}
  }, 
  GET_CHANGE_LOG (state, data) {
    state.change_logs = data.data
  },
  GET_SINGLE_CHANGE_LOG(state, data) {
  
    state.single_change_log = data
  },

}
